import { render, staticRenderFns } from "./Type2Verify.vue?vue&type=template&id=2222ce70&scoped=true"
import script from "./Type2Verify.vue?vue&type=script&lang=js"
export * from "./Type2Verify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2222ce70",
  null
  
)

export default component.exports